/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const createNumberValidation = (fieldName) =>
    Yup.number()
        .typeError(`Invalid data. '${fieldName}' must be a number`)
        .nullable(true)
        .test('is-number', `Invalid data. '${fieldName}' must be a number`, function (value) {
            // Si el valor es null, undefined o una cadena vacía, lo consideramos válido
            if (value === null || value === undefined || value === '') {
                return true;
            }

            // Validamos que sea un número y que no sea NaN ni infinito
            if (!isNaN(value) && isFinite(value)) {
                return true;
            }

            // Si no cumple ninguna de las condiciones anteriores, generamos un error
            return this.createError({ message: `Invalid data. '${fieldName}' must be a number` });
        });

const TODIS_LP_SCHEMA = Yup.object().shape({
    //general section Rules:
    startKm: createNumberValidation('Start km'),
    endKm: createNumberValidation('End km'),
    /* dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true), */
    dateValidFor: Yup.string("Valid for is a Year"),
    tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    routeId: Yup.string("Route ID is alphanumeric").nullable(true),
    nationalRouteId: Yup.string("National Route ID is alphanumeric").nullable(true),
    internatRouteId: Yup.string("International Route ID is alphanumeric").nullable(true),
    startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
    endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
    general_status: Yup.string("Status").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),


    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
            if (value === null || value === undefined) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            // Verificar si es una cadena antes de intentar dividirla
            if (typeof value === 'string') {
                const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

                for (const email of emails) {
                    if (!emailRegex.test(email.trim())) {
                        throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                    }
                }
            }

            return true;
        }),

    regionalPartner: Yup.string("Regional Partner").nullable(true),
    startKmDirA: createNumberValidation('Start km (Direction A)'),
    startKmDirB: createNumberValidation('Start km (Direction B)'),
    endKmDirA: createNumberValidation('End km (Direction A)'),
    endKmDirB: createNumberValidation('End km (Direction B)'),
    targetTentSec: Yup.string("Targeted TEN-T section(s) (current network layout)").nullable(true),
    newTentSec: Yup.string("New TEN-T section(s) (after project's implementation)").nullable(true),
    immedPartTentNet: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),

    roadsLiveNmDTO: Yup.object().shape({
        targetTentNet: Yup.string('Value should be a text').nullable(true),
        targetTentSec: Yup.string().nullable(true),
        newTentSec: Yup.string().nullable(true),
        newTentSecLength: Yup.number().nullable(true),
        newTentSecLanes: Yup.number().nullable(true),
        newTentSecPavCond: Yup.string().nullable(true),
        newTentSecItsComp: Yup.string().nullable(true),
        newTentSecAltFuels: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsLivePmDescDTO: Yup.object().shape({

        projectName: Yup.string('Value should be a text').nullable(true),
        typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
        length: createNumberValidation('Length (if linear)(km)'),
        totalCostCapex: createNumberValidation('Total Cost (CAPEX)(Euro)'),
        lanesDirA: createNumberValidation('No. of Lanes (Direction A)'),
        lanesDirB: createNumberValidation('No. of Lanes (Direction B)'),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsLivePmEligiTentDTO: Yup.object().shape({

        motorwayExpress: Yup.boolean().nullable(true),
        otherHighQualiRoads: Yup.boolean().nullable(true),
        rehabReconstru: Yup.boolean().nullable(true),
        alternativeFuels: Yup.boolean().nullable(true),
        itsComp: Yup.string().nullable(true),
        tollingInterope: Yup.string().nullable(true),
        safetyComp: Yup.boolean().nullable(true),
        tunnelComp: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        separationRoadCarriageways: Yup.boolean().nullable(true),
        noCrossingsAtGrade: Yup.boolean().nullable(true),
        restAreasAvailability: Yup.boolean().nullable(true),
        safeParkingAvailability: Yup.boolean().nullable(true),
        weighInMotionSystems: Yup.boolean().nullable(true),
        detectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
        alternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        alternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        alternativeFuelsHydrogen: Yup.boolean().nullable(true),
        alternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true)
    }),
    roadsLivePmIndicatorsDTO: Yup.object().shape({
        siAnnTraffDemGro: Yup.number()
            .typeError("Invalid data. 'Annual traffic demand growth (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Annual traffic demand growth (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Annual traffic demand growth (%)\' must be a number' });
                }
                return true;
            }),
        siModalTrans: Yup.number()
            .typeError("Invalid data. 'Modal transfer - if applicable (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Modal transfer - if applicable (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Modal transfer - if applicable (%)\' must be a number' });
                }
                return true;
            }),
        siAnnTraffAcciRateRed: Yup.number()
            .typeError("Invalid data. 'Annual accident rate reduction - if applicable (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Annual accident rate reduction - if applicable (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Annual accident rate reduction - if applicable (%)\' must be a number' });
                }
                return true;
            }),
        eiEirr: Yup.number()
            .typeError("Invalid data. 'Economic internal rate of return (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Economic internal rate of return (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Economic internal rate of return (%)\' must be a number' });
                }
                return true;
            }),
        eiNpv: Yup.number()
            .typeError("Invalid data. 'Net present value (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Net present value (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Net present value (Euro)\' must be a number' });
                }
                return true;
            }),
        eiSdr: Yup.number()
            .typeError("Invalid data. 'Social discount rate (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Social discount rate (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Social discount rate (%)\' must be a number' });
                }
                return true;
            }),
        eiProjPlanDesCost: Yup.number()
            .typeError("Invalid data. 'Project planning & design cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Project planning & design cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Project planning & design cost (Euro)\' must be a number' });
                }
                return true;
            }),
        eiProjConstCost: Yup.number()
            .typeError("Invalid data. 'Project construction cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Project construction cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Project construction cost (Euro)\' must be a number' });
                }
                return true;
            }),
        eiTotalProjCost: Yup.number()
            .typeError("Invalid data. 'Total project cost (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Total project cost (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Total project cost (Euro)\' must be a number' });
                }
                return true;
            }),
        fiFirr: Yup.number()
            .typeError("Invalid data. 'FIRR (Financial Internal Rate of Return)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'FIRR (Financial Internal Rate of Return)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'FIRR (Financial Internal Rate of Return)\' must be a number' });
                }
                return true;
            }),
        fiFnpv: Yup.number()
            .typeError("Invalid data. 'Financial net present value (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Financial net present value (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Financial net present value (Euro)\' must be a number' });
                }
                return true;
            }),
        fiFdr: Yup.number()
            .typeError("Invalid data. 'Financial discount rate (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Financial discount rate (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Financial discount rate (%)\' must be a number' });
                }
                return true;
            }),
        fiWacc: Yup.number()
            .typeError("Invalid data. 'Weighted average cost of capital (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Weighted average cost of capital (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Weighted average cost of capital (%)\' must be a number' });
                }
                return true;
            }),
        fiFirtsYearProf: Yup.date("Valid from is a Date").nullable(true),
        fiDscr: Yup.number()
            .typeError("Invalid data. 'Debt service coverage ratio (%)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Debt service coverage ratio (%)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Debt service coverage ratio (%)\' must be a number' });
                }
                return true;
            }),
        eniCo2Ems: Yup.number()
            .typeError("Invalid data. 'CO2 emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'CO2 emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'CO2 emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNoxEms: Yup.number()
            .typeError("Invalid data. 'Nox emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Nox emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Nox emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniSo2Ems: Yup.number()
            .typeError("Invalid data. 'SO2 emissions (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'SO2 emissions (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'SO2 emissions (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNmhcEms: Yup.number()
            .typeError("Invalid data. 'Non-methane hydrocarbons (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Non-methane hydrocarbons (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Non-methane hydrocarbons (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniPpm: Yup.number()
            .typeError("Invalid data. 'Particulate matter – ppm (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Particulate matter – ppm (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Particulate matter – ppm (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniNoiseLevel: Yup.number()
            .typeError("Invalid data. 'Noise levels along the section (+/- %)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Noise levels along the section (+/- %)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Noise levels along the section (+/- %)\' must be a number' });
                }
                return true;
            }),
        eniCliChangeRes: Yup.string("tent category is alphanumeric").nullable(true),
        eniProteNatuaAff: Yup.number()
            .typeError("Invalid data. 'Protected natural areas affected (km2)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Protected natural areas affected (km2)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Protected natural areas affected (km2)\' must be a number' });
                }
                return true;
            }),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsLivePmPiDTO: Yup.object().shape({
        forecastConstPeriod: Yup.number('Value should be number').nullable(true),
        actualConstPeriod: Yup.number('Value should be number').nullable(true),
        forecastCapex: Yup.number('Value should be number').nullable(true),
        actualCapex: Yup.number('Value should be number').nullable(true),
        forecastOpex: Yup.number('Value should be number').nullable(true),
        actualOpex: Yup.number('Value should be number').nullable(true),
        forecastMaintCost: Yup.number('Value should be number').nullable(true),
        actualMaintCost: Yup.number('Value should be number').nullable(true),
        interestDuringConst: Yup.string('Value should be a text').nullable(true),
        ebitda: Yup.string('Value should be a text').nullable(true),
        forecastRevenue: Yup.number('Value should be number').nullable(true),
        actualRevenue: Yup.number('Value should be number').nullable(true),
        forecastPassCars: Yup.string('Value should be a text').nullable(true),
        actualPassCars: Yup.string('Value should be a text').nullable(true),
        forecastBusses: Yup.string('Value should be a text').nullable(true),
        actualBusses: Yup.string('Value should be a text').nullable(true),
        forecastTrucks: Yup.string('Value should be a text').nullable(true),
        actualTrucks: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsLivePmStatusDTO: Yup.object().shape({
        implemented: Yup.string('Value should be a text').nullable(true),
        ongoingProjFs: Yup.string('Value should be a text').nullable(true),
        matureProjFs: Yup.string('Value should be a text').nullable(true),
        projUnderPrep: Yup.string('Value should be a text').nullable(true),
        projStatusDesc: Yup.string('Value should be a text').nullable(true),
        projFundNatBudg: Yup.number()
            .typeError("Invalid data. 'National Budget (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'National Budget (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'National Budget (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundNatBudgAllo: Yup.boolean().nullable(true),
        projFundWb: Yup.number()
            .typeError("Invalid data. 'World Bank (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'World Bank (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'World Bank (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundWbAllo: Yup.boolean().nullable(true),
        projFundEbrd: Yup.number()
            .typeError("Invalid data. 'EBRD (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EBRD (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EBRD (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundEbrdAllo: Yup.boolean().nullable(true),
        projFundEib: Yup.number()
            .typeError("Invalid data. 'EIB (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EIB (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EIB (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundEibAllo: Yup.boolean().nullable(true),
        otherIfi: Yup.number()
            .typeError("Invalid data. 'Other IFI (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Other IFI (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Other IFI (Euro)\' must be a number' });
                }
                return true;
            }),
        otherIfiSpec: Yup.string('Value should be a text').nullable(true),
        otherIfiAllo: Yup.boolean().nullable(true),
        concession: Yup.number()
            .typeError("Invalid data. 'Concessions (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Concessions (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Concessions (Euro)\' must be a number' });
                }
                return true;
            }),
        concessionSpec: Yup.string('Value should be a text').nullable(true),
        concessionAllo: Yup.boolean().nullable(true),
        euFund: Yup.number()
            .typeError("Invalid data. 'EU Fund (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'EU Fund (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'EU Fund (Euro)\' must be a number' });
                }
                return true;
            }),
        euFundSpec: Yup.string('Value should be a text').nullable(true),
        euFundAllo: Yup.boolean().nullable(true),
        otherFund: Yup.number()
            .typeError("Invalid data. 'Other funding source (name)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Other funding source (name)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Other funding source (name)\' must be a number' });
                }
                return true;
            }),
        otherFundSpec: Yup.string('Value should be a text').nullable(true),
        otherFundAllo: Yup.boolean().nullable(true),
        preFeasiStudy: Yup.boolean().nullable(true),
        feasiStudy: Yup.boolean().nullable(true),
        conceptDesign: Yup.boolean().nullable(true),
        prelimDesign: Yup.boolean().nullable(true),
        detailDesign: Yup.boolean().nullable(true),
        environImpactAssess: Yup.boolean().nullable(true),
        projFeasiStudyTitley: Yup.string('Value should be a text').nullable(true),
        projFeasiStudyPrepBy: Yup.string('Value should be a text').nullable(true),
        projFeasiStudySupervBy: Yup.string('Value should be a text').nullable(true),
        conceptDesignTitle: Yup.string('Value should be a text').nullable(true),
        conceptDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        conceptDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        prelimDesignTitle: Yup.string('Value should be a text').nullable(true),
        prelimDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        prelimDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        detailDesignTitle: Yup.string('Value should be a text').nullable(true),
        detailDesignPrepBy: Yup.string('Value should be a text').nullable(true),
        detailDesignSupervBy: Yup.string('Value should be a text').nullable(true),
        environImpactAssessTitle: Yup.string('Value should be a text').nullable(true),
        environImpactAssessPrepBy: Yup.string('Value should be a text').nullable(true),
        environImpactAssessSupervBy: Yup.string('Value should be a text').nullable(true),
        tenderStartDateInitFore: Yup.date("Valid to is a Date").nullable(true),
        tenderStartDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        tenderStartDateActual: Yup.date("Valid to is a Date").nullable(true),
        designCompDateFore: Yup.date("Valid to is a Date").nullable(true),
        designCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        designCompDateActual: Yup.date("Valid to is a Date").nullable(true),
        projCompDateFore: Yup.date("Valid to is a Date").nullable(true),
        projCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsLivePmTentcompDTO: Yup.object().shape({
        befProjImpTentComp: Yup.boolean().nullable(true),
        aftProjImpTentComp: Yup.boolean().nullable(true),
        befAltFuelsAvai: Yup.boolean().nullable(true),
        aftAltFuelsAvai: Yup.boolean().nullable(true),
        befItsComp: Yup.string().nullable(true),
        aftItsComp: Yup.string().nullable(true),
        befTollInterop: Yup.string().nullable(true),
        aftTollInterop: Yup.string().nullable(true),
        befTunnelComp: Yup.string().nullable(true),
        aftTunnelComp: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        befSeparationRoadCarriageways: Yup.boolean().nullable(true),
        aftSeparationRoadCarriageways: Yup.boolean().nullable(true),
        befNoCrossingsAtGrade: Yup.boolean().nullable(true),
        aftNoCrossingsAtGrade: Yup.boolean().nullable(true),
        befRestAreasAvailability: Yup.boolean().nullable(true),
        aftRestAreasAvailability: Yup.boolean().nullable(true),
        befSafeParkingAvailability: Yup.boolean().nullable(true),
        aftSafeParkingAvailability: Yup.boolean().nullable(true),
        befWeighInMotionSystems: Yup.boolean().nullable(true),
        aftWeighInMotionSystems: Yup.boolean().nullable(true),
        befDetectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
        aftDetectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
        befAlternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        aftAlternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        befAlternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        aftAlternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        befAlternativeFuelsHydrogen: Yup.boolean().nullable(true),
        aftAlternativeFuelsHydrogen: Yup.boolean().nullable(true),
        befAlternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true),
        aftAlternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true),
    }),
});

const LP_INIT = {
    //general section Rules: 
    startKm: "",
    endKm: "",
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tenTCategory: "",
    routeId: "",
    nationalRouteId: "",
    internatRouteId: "",
    startNodeName: "",
    endNodeName: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    regionalPartner: "",
    startKmDirA: "",
    startKmDirB: "",
    endKmDirA: "",
    endKmDirB: "",
    targetTentSec: "",
    newTentSec: "",
    immedPartTentNet: false,
    remarks: "",
    //Description
    roadsLiveNmDTO: {
        targetTentNet: "",
        targetTentSec: "",
        newTentSec: "",
        newTentSecLength: "",
        newTentSecLanes: "",
        newTentSecPavCond: "",
        newTentSecItsComp: "",
        newTentSecAltFuels: "",
        remarks: ""
    },
    roadsLivePmDescDTO: {
        projectName: "",
        typeForeseenInterven: "",
        length: "",
        lanesDirA: "",
        lanesDirB: "",
        totalCostCapex: "",
        remarks: ""
    },
    roadsLivePmEligiTentDTO: {
        motorwayExpress: false,
        otherHighQualiRoads: false,
        rehabReconstru: false,
        alternativeFuels: false,
        itsComp: "",
        tollingInterope: "",
        safetyComp: false,
        tunnelComp: false,
        description: "",
        separationRoadCarriageways: "",
        noCrossingsAtGrade: "",
        restAreasAvailability: "",
        safeParkingAvailability: "",
        weighInMotionSystems: "",
        detectProvideSafetyTrafficInformation: "",
        alternativeFuelsElectricityLight: false,
        alternativeFuelsElectricityHeavy: false,
        alternativeFuelsHydrogen: false,
        alternativeFuelsLiquifiedMethane: false
    },
    roadsLivePmIndicatorsDTO: {
        siAnnTraffDemGro: "",
        siModalTrans: "",
        siAnnTraffAcciRateRed: "",
        eiEirr: "",
        eiNpv: "",
        eiSdr: "",
        eiProjPlanDesCost: "",
        eiProjConstCost: "",
        eiTotalProjCost: "",
        fiFirr: "",
        fiFnpv: "",
        fiFdr: "",
        fiWacc: "",
        fiFirtsYearProf: "",
        fiDscr: "",
        eniCo2Ems: "",
        eniNoxEms: "",
        eniSo2Ems: "",
        eniNmhcEms: "",
        eniPpm: "",
        eniNoiseLevel: "",
        eniCliChangeRes: "",
        eniProteNatuaAff: "",
        remarks: ""
    },
    roadsLivePmPiDTO: {
        forecastConstPeriod: "",
        actualConstPeriod: "",
        forecastCapex: "",
        actualCapex: "",
        forecastOpex: "",
        actualOpex: "",
        forecastMaintCost: "",
        actualMaintCost: "",
        interestDuringConst: "",
        ebitda: "",
        forecastRevenue: "",
        actualRevenue: "",
        forecastPassCars: "",
        actualPassCars: "",
        forecastBusses: "",
        actualBusses: "",
        forecastTrucks: "",
        actualTrucks: "",
        remarks: ""
    },
    roadsLivePmStatusDTO: {
        implemented: "",
        ongoingProjFs: "",
        matureProjFs: "",
        projUnderPrep: "",
        projStatusDesc: "",
        projFundNatBudg: "",
        projFundNatBudgAllo: false,
        projFundWb: "",
        projFundWbAllo: false,
        projFundEbrd: "",
        projFundEbrdAllo: false,
        projFundEib: "",
        projFundEibAllo: false,
        otherIfi: "",
        otherIfiSpec: "",
        otherIfiAllo: false,
        concession: "",
        concessionSpec: "",
        concessionAllo: false,
        euFund: "",
        euFundSpec: "",
        euFundAllo: false,
        otherFund: "",
        otherFundSpec: "",
        otherFundAllo: false,
        preFeasiStudy: false,
        feasiStudy: false,
        conceptDesign: false,
        prelimDesign: false,
        detailDesign: false,
        environImpactAssess: false,
        projFeasiStudyTitley: "",
        projFeasiStudyPrepBy: "",
        projFeasiStudySupervBy: "",
        conceptDesignTitle: "",
        conceptDesignPrepBy: "",
        conceptDesignSupervBy: "",
        prelimDesignTitle: "",
        prelimDesignPrepBy: "",
        prelimDesignSupervBy: "",
        detailDesignTitle: "",
        detailDesignPrepBy: "",
        detailDesignSupervBy: "",
        environImpactAssessTitle: "",
        environImpactAssessPrepBy: "",
        environImpactAssessSupervBy: "",
        tenderStartDateInitFore: "",
        tenderStartDateCurrEst: "",
        tenderStartDateActual: "",
        designCompDateFore: "",
        designCompDateCurrEst: "",
        designCompDateActual: "",
        projCompDateFore: "",
        projCompDateCurrEst: "",
        remarks: ""
    },
    roadsLivePmTentcompDTO: {
        befProjImpTentComp: false,
        aftProjImpTentComp: false,
        befAltFuelsAvai: false,
        aftAltFuelsAvai: false,
        befItsComp: "",
        aftItsComp: "",
        befTollInterop: "",
        aftTollInterop: "",
        befTunnelComp: "",
        aftTunnelComp: "",
        safetyCompBefProjImp: false,
        safetyCompAftProjImp: false,
        remarks: "",
        befSeparationRoadCarriageways: false,
        aftSeparationRoadCarriageways: false,
        befNoCrossingsAtGrade: false,
        aftNoCrossingsAtGrade: false,
        befRestAreasAvailability: false,
        aftRestAreasAvailability: false,
        befSafeParkingAvailability: false,
        aftSafeParkingAvailability: false,
        befWeighInMotionSystems: false,
        aftWeighInMotionSystems: false,
        befDetectProvideSafetyTrafficInformation: false,
        aftDetectProvideSafetyTrafficInformation: false,
        befAlternativeFuelsElectricityLight: false,
        aftAlternativeFuelsElectricityLight: false,
        befAlternativeFuelsElectricityHeavy: false,
        aftAlternativeFuelsElectricityHeavy: false,
        befAlternativeFuelsHydrogen: false,
        aftAlternativeFuelsHydrogen: false,
        befAlternativeFuelsLiquifiedMethane: false,
        aftAlternativeFuelsLiquifiedMethane: false
    },
}

export { TODIS_LP_SCHEMA, LP_INIT };